import React from "react";
import {Alert, Button, Space} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {RootStoreContext} from "../../../../../stores/root/root";
import {OrderData} from "../../../../../models/orders/order-data/order.data";
import {Price} from "../../../../core/commons/price/price";
import {useRequiredLayers} from "../../../../../utils/context";
import {RootControllersContext} from "../../../../../controllers/root/root.controllers";

interface OrderPayButtonProps {
    order: OrderData;
}

export const OrderPayWidget: React.FC<OrderPayButtonProps> = ({order}) => {

    const {store: {authStore}, controller: {loginController}} = useRequiredLayers(RootStoreContext, RootControllersContext)

    if (!authStore.lz.py) {
        return null;
    }

    return (
        <>{!order.paid ? (<>
                {order.allowToPay ? (
                    <Space style={{justifyContent: "end"}} direction={"horizontal"}>
                        <a href={loginController.generateUri("/api/v3/payments/order/" + order.id)} target={"_blank"} rel={"noreferrer"}>
                            <Button
                                icon={<FontAwesomeIcon icon={["fas", "credit-card"]}/>}
                                type={"primary"}
                            >
                                <span style={{padding: "0 3px 0 10px"}}>Pay</span>
                                <Price value={order.stockSummary.grandTotal}/>
                            </Button>
                        </a>
                    </Space>
                ) : (
                    <Alert
                        showIcon
                        description={"You can pay in a few minutes when the warehouse confirms the availability of the goods"}
                        message={"Thanks for your order!"}
                    />
                )}
            </>
            ) : null}
        </>
    )
}